<div class="product-top-filter">
    <div class="row">
        <div class="col-12">
            <div class="product-filter-content">
                <div class="search-count">
                    <h5 class="center">{{title}}</h5>
                </div>
                <div class="collection-grid-view center" *ngIf="layoutView == 'grid-view'">
                    <ul class="center">
                        <li (click)="setGridLayout('col-lg-6')">
                            <img src="assets/images/icon/2.png" class="product-2-layout-view">
                        </li>
                        <li (click)="setGridLayout('col-lg-4')">
                            <img src="assets/images/icon/3.png" class="product-3-layout-view">
                        </li>
                        <li (click)="setGridLayout('col-lg-3')">
                            <img src="assets/images/icon/4.png" class="product-4-layout-view">
                        </li>
                        <li (click)="setGridLayout('col-lg-2')">
                            <img src="assets/images/icon/6.png" class="product-6-layout-view">
                        </li>
                    </ul>
                </div>
                <div class="product-page-filter">
                    <select (change)="sorting($event)">
                        <option value=""> {{'sort' | translate }} </option>
                        <option value="a-z" [selected]="sortBy == 'a-z'"> {{'sort-a-z' | translate }}</option>
                        <option value="z-a" [selected]="sortBy == 'z-a'"> {{'sort-z-a' | translate }}</option>
                        <option value="low" [selected]="sortBy == 'low'"> {{'sort-l-h' | translate }}</option>
                        <option value="high" [selected]="sortBy == 'high'"> {{'sort-h-l' | translate }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>